<template>
  <div class="template-import-dialog">
    <el-dialog
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      :before-close="cancel"
      width="600px"
      class="template-list__import-dialog"
      style="padding: 10px"
    >
      <div slot="title">
        <span class="dialog-title">{{ $t("templateInfo.Import") }}</span>
      </div>
      <div v-if="dialogVisible">
        <el-form ref="form" :model="form" :rules="rules" size="small">
          <el-row type="flex" justify="center">
            <el-col :span="12">
              <el-form-item>
                <div class="search-body">
                  <div class="search-item">
                    <div class="result-status__checked" />
                    <span class="search-item__span">JSON</span>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item
                :label="$t('templateInfo.Scenarios')"
                prop="scenarioId"
                required
                label-width="105px"
              >
                <el-select
                  v-model="form.scenarioId"
                  :placeholder="
                    $t('layout.Select') + ' ' + $t('templateInfo.Scenarios')
                  "
                >
                  <el-option
                    v-for="item in sceneList"
                    :key="item.scenarioId"
                    :label="item.translateTextName"
                    :value="item.scenarioId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item
                v-if="userData.userType === 203"
                :label="$t('itemsScenarios.ViewDialog.VisibleRange')"
                required
                label-width="105px"
              >
                <el-radio-group v-model="form.openType" style="width: 400px">
                  <el-radio :label="0">
                    {{ $t("itemsScenarios.ViewDialog.ThisStore") }}
                  </el-radio>
                  <el-radio :label="1">
                    {{ $t("itemsScenarios.ViewDialog.AllStore") }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item
                :label="$t('templateInfo.File')"
                prop="File"
                label-width="105px"
              >
                <el-upload
                  class="upload-demo"
                  action="none"
                  drag
                  :limit="1"
                  :auto-upload="false"
                  :on-change="setUploadData"
                  accept=".json"
                >
                  <i class="el-icon-upload" />
                  <div class="el-upload__text">
                    {{ $t("templateInfo.ImportTips") }}
                  </div>
                  <div slot="tip" class="el-upload__tip">
                    {{ $t("templateInfo.ImportType") }}
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer__layout__2">
          <el-button class="button-cancel" @click="handleCancel" size="small">
            {{ $t("button.Cancel") }}
          </el-button>
          <el-button class="button-next" @click="handleNext" size="small">
            {{ $t("button.Next") }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { templateImport } from "@/libs/api/taskManger.js";
import modelUi from "@/views/taskManagement/taskManger/utils/modelUi.js";
import {
  parseResp,
  parseError,
} from "@/views/taskManagement/taskManger/utils/requestUtil.js";
// import de from '../svg-tool/src/editor/extensions/ext-storage/locale/de'

export default {
  components: {},
  data() {
    return {
      userData:JSON.parse(localStorage.getItem('userData')),
      dialogVisible: false,
      form: {
        scenarioId: '',
        openType: 0
      },
      uploadFile: null,
      formData: null,
      sceneList:[],
      rules: {
        scenarioId: {
          required: true,
          message: "Select to Items",
          trigger: "change",
        },
        openType: {
          required: true,
          message: "Select to open type",
          trigger: "change",
        },
        File: {
          required: true,
          message: "Select to File",
          trigger: "change",
        },
      },
    };
  },
  methods: {
    openDialog() {
      this.dialogVisible = true;
      this.getScenarioList()
    },
    cancel() {
      this.dialogVisible = false;
    },
    fileChange() {},
    fileVisibleChange(val) {
      if (val && this.fileList.length === 0) {
      }
    },
    handleCancel() {
      this.dialogVisible = false;
    },

    async getScenarioList() {
      const { data } = await this.$Api.getNewScenarioList();
      this.sceneList = data || [];
    },

    setUploadData(file) {
      this.uploadFile = file.raw;
    },
    handleNext() {
      if(!this.form.scenarioId){
        this.$message.error(this.$t("assocaite.DiologOne.Select a Scenario"));
        return
      }
      if(!this.uploadFile){
        this.$message.error(this.$t("lcd.NewAdd.Upload json file"));
        return
      }

      const formData = new FormData();
      formData.append('file', this.uploadFile);
      formData.append('scenarioId', this.form.scenarioId);
      formData.append('openType', this.form.openType);
      formData.append('storeId', localStorage.getItem("storeId"));
      templateImport(formData)
        .then((res) => {
          const result = parseResp(res);
          if (result.success) {
            this.$message({
              message: this.$t("templateInfo.ImportSucess"),
              type: "success",
            });
            this.dialogVisible = false;
            this.form =  {
              scenarioId: '',
              openType: 0
            }
            this.uploadFile = null
            this.$emit("refresh");
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((err) => {
          this.$message.error(parseError(err));
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.template-import-dialog {
  .template-list__import-dialog {
    .el-dialog__header {
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
    }

    .el-dialog__body {
      padding: 30px 20px !important;
    }

    .dialog-footer__layout__2 {
      display: flex;
      justify-content: center;
      margin-top: 50px;
    }

    .search-body {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .search-item {
      display: flex;
      align-items: center;
      height: 60px;
      margin: 0px 10px;
    }

    .search-item__span {
      color: #555555;
      font-size: 16px;
    }

    .result-status__checked {
      width: 20px;
      height: 20px;
      background: #ffffff;
      border-radius: 13px;
      border: 5px solid #3461ff;
      margin: 0px;
      margin-right: 10px;
    }

    .button-cancel {
      background-color: #d1d1d1;
      border: 0px;
      color: #000;
      width: 120px;
      margin-left: 10px;
      margin-right: 10px;
    }

    .button-next {
      background-color: #17b54d;
      border: 0px;
      color: #ffffff;
      width: 120px;
      margin-left: 10px;
      margin-right: 10px;
    }
  }

  // 重置样式
  ::v-deep .el-dialog {
    margin-top: 5vh !important;
  }
}
</style>
